export const unstuckMap = {
    "1": {
        cards: [
            { title: "Do you understand the users?", description: "", className: "moment-of-struggle" }
        ],
        connections: [
            { className: "no-button", node: "5", displayText: "No" },
            { className: "yes-button", node: "2", displayText: "Yes" }
        ]
    },
    "2": {
        cards: [
            { title: "Do you know what the problem is?", description: "", className: "moment-of-struggle" }
        ],
        connections: [
            { className: "no-button", node: "16", displayText: "No" },
            { className: "yes-button", node: "3", displayText: "Yes" }
        ]
    },
    "3": {
        cards: [
            { title: "Do you know how to solve the problem?", description: "", className: "moment-of-struggle" }
        ],
        connections: [
            { className: "no-button", node: "29", displayText: "No" },
            { className: "yes-button", node: "4", displayText: "Yes" }
        ]
    },
    "4": {
        cards: [
            { title: "Do you understand the opportunity?", description: "", className: "moment-of-struggle" }
        ],
        connections: [
            { className: "no-button", node: "43", displayText: "No" },
            { className: "yes-button", node: "1", displayText: "Yes" }
        ]
    },
    "5": {
        cards: [
            { title: "Do you know which users will help you tackle the opportunity?", description: "", className: "question" }
        ],
        connections: [
            { className: "no-button", node: "6", displayText: "No" },
            { className: "yes-button", node: "7", displayText: "Yes" }
        ]
    },
    "6": {
        cards: [
            { title: "GO BACK TO OPPORTUNITY", description: "When you try to market to everyone, you reach no one.", className: "breakpoint" }
        ],
        connections: [
            { className: "yes-button", node: "4", displayText: "Go" }
        ]
    },
    "7": {
        cards: [
            { title: "Do you know who these users are?", description: "", className: "question" }
        ],
        connections: [
            { className: "no-button", node: "8", displayText: "No" },
            { className: "yes-button", node: "9", displayText: "Yes" }
        ]
    },
    "8": {
        cards: [
            { title: "Do you know how these users behave?", description: "", className: "question" }
        ],
        connections: [
            { className: "no-button", node: "11", displayText: "No" },
            { className: "yes-button", node: "10", displayText: "Yes" }
        ]
    },
    "9": {
        cards: [
            { title: "Do you know what these users value?", description: "", className: "question" }
        ],
        connections: [
            { className: "no-button", node: "12", displayText: "No" },
            { className: "yes-button", node: "13", displayText: "Yes" }
        ]
    },
    "10": {
        cards: [
            { title: "Did you talk to these users?", description: "", className: "question" }
        ],
        connections: [
            { className: "no-button", node: "15", displayText: "No" },
            { className: "yes-button", node: "14", displayText: "Yes" }
        ]
    },
    "11": {
        cards: [
            { title: "CUSTOMER FORCES", description: "Motivational forces that drive customer toward a solution", className: "proposed-framework" },
            { title: "DATA ANALYSIS", description: "How users behave.", className: "proposed-method" }
        ]
    },
    "12": {
        cards: [
            { title: "KANO ANALYSIS", description: "Customers' basic expectations, delighters and satisfiers.", className: "proposed-framework" },
            { title: "CUSTOMER JOURNEY MAP", description: "Users' feelings, motivations and all touchpoints.", className: "proposed-framework" }
        ]
    },
    "13": {
        cards: [
            { title: "TARGET AUDIENCE", description: "Deep understanding of the users we are solving the problem for", className:"unstuck-achievement" }
        ]
    },
    "14": {
        cards: [
            { title: "PAIN-GAIN MAP", description: "What motivates and influences user decisions.", className: "proposed-framework" },
            { title: "EMPATHY MAP", description: "What users think & feel, see & hear, say & do and need & desire.", className: "proposed-framework" }
        ]
    },
    "15": {
        cards: [
            { title: "SURVEY", description: "What users like or dislike about the current solution.", className: "proposed-method" },
            { title: "DEEP-DIVE INTERVIEW", description: "Gains, pains, desires, underserved needs, wants, anxieties and motivations of users.", className: "proposed-method" },
            { title: "CO-CREATION", description: "User attitudes, expectations, ideas, and perceptions towards the product.", className: "proposed-method" }
        ]
    },
    "16": {
        cards: [
            { title: "Do you understand the user you're solving the problem for?", description: "", className: "question" }
        ],
        connections: [
            { className: "no-button", node: "17", displayText: "No" },
            { className: "yes-button", node: "18", displayText: "Yes" }
        ]
    },
    "17": {
        cards: [
            { title: "GO BACK TO USERS", description: "You cannot solve a problem for people you don't understand", className: "breakpoint" }
        ],
        connections: [
            { className: "yes-button", node: "1", displayText: "Go" }
        ]
    },
    "18": {
        cards: [
            { title: "Did you identify a problem these users have?", description: "", className: "question" }
        ],
        connections: [
            { className: "no-button", node: "20", displayText: "No" },
            { className: "yes-button", node: "21", displayText: "Yes" }
        ]
    },
    "19": {
        cards: [
            { title: "Do you understand what users are trying to achieve?", description: "", className: "question" }
        ],
        connections: [
            { className: "no-button", node: "22", displayText: "No" },
            { className: "yes-button", node: "23", displayText: "Yes" }
        ]
    },
    "20": {
        cards: [
            { title: "Can you assume problems out of the existing pains, needs, wants and desires?", description: "", className: "question" }
        ],
        connections: [
            { className: "no-button", node: "19", displayText: "No" },
            { className: "yes-button", node: "24", displayText: "Yes" }
        ]
    },
    "21": {
        cards: [
            { title: "Do you know if this is a real problem?", description: "", className: "moment-of-struggle" }
        ],
        connections: [
            { className: "no-button", node: "25", displayText: "No" },
            { className: "yes-button", node: "26", displayText: "Yes" }
        ]
    },
    "22": {
        cards: [
            { title: "JTBD INTERVIEW", description: "When do people struggle to get a desired outcome.", className: "proposed-method" },
            { title: "5W's", description: "The who, what, where, when and why of the problem.", className: "proposed-method" },
            { title: "5 WHYS", description: "The root cause behind a statement or an action. The context of the problem.", className: "proposed-method" }
        ]
    },
    "23": {
        cards: [
            { title: "JOBS-TO-BE-DONE CANVAS", description: "What causes people to hire the product.", className: "proposed-framework" }
        ]
    },
    "24": {
        cards: [
            { title: "PROBLEM HYPOTHESES", description: "The riskiest assumptions about the user problem.", className: "proposed-framework" }
        ]
    },
    "25": {
        cards: [
            { title: "SURVEY", description: "For how many users this problem is valid and considered as important to get solved.", className: "proposed-method" },
            { title: "USER INTERVIEW", description: "Why and when people want to get the problem solved.", className: "proposed-method" }
        ]
    },
    "26": {
        cards: [
            { title: "Is it a big enough problem worth solving?", description: "", className: "question" }
        ],
        connections: [
            { className: "no-button", node: "28", displayText: "No" },
            { className: "yes-button", node: "27", displayText: "Yes" }
        ]
    },
    "27": {
        cards: [
            { title: "PROBLEM STATEMENT", description: "Deep understanding of the problem we are trying to solve", className:"unstuck-achievement" },
            { title: "POSTER SESSION", description: "Clear up the wall and summarize research insights.", className: "proposed-method" }
        ]
    },
    "28": {
        cards: [
            { title: "GO-/NO-GO DECISION", description: "", className: "breakpoint" },
            { title: "GO BACK TO OPPORTUNITY", description: "", className: "breakpoint" }
        ],
        connections: [
            { className: "yes-button", node: "4", displayText: "Go" }
        ]
    },
    "29": {
        cards: [
            { title: "Do you know which problem to tackle?", description: "", className: "question" }
        ],
        connections: [
            { className: "no-button", node: "30", displayText: "No" },
            { className: "yes-button", node: "31", displayText: "Yes" }
        ]
    },
    "30": {
        cards: [
            { title: "GO BACK TO PROBLEM", description: "Don't you dare thinking about a solution!", className: "breakpoint" }
        ],
        connections: [
            { className: "yes-button", node: "2", displayText: "Go" }
        ]
    },
    "31": {
        cards: [
            { title: "Did you identify possible solutions?", description: "", className: "question" }
        ],
        connections: [
            { className: "no-button", node: "32", displayText: "No" },
            { className: "yes-button", node: "36", displayText: "Yes" }
        ]
    },
    "32": {
        cards: [
            { title: "Do you need help creating promising solutions?", description: "", className: "question" }
        ],
        connections: [
            { className: "no-button", node: "33", displayText: "No" },
            { className: "yes-button", node: "34", displayText: "Yes" }
        ]
    },
    "33": {
        cards: [
            { title: "Do you quickly need a vast range of ideas?", description: "", className: "question" }
        ],
        connections: [
            { className: "no-button", node: "31", displayText: "No" },
            { className: "yes-button", node: "35", displayText: "Yes" }
        ]
    },
    "34": {
        cards: [
            { title: "IMPACT MAP", description: "Features aligned to business objectives or user needs.", className: "proposed-framework" },
            { title: "DESIGN SPRINT", description: "How to identify, build and test possible solutions.", className: "proposed-method" }
        ]
    },
    "35": {
        cards: [
            { title: "DESIGN STUDIO", description: "Inspiration on possible solutions for a problem.", className: "proposed-method" },
            { title: "IDEATION", description: "Inspiration on possible solutions for a problem.", className: "proposed-method" }
        ]
    },
    "36": {
        cards: [
            { title: "VALUE PROPOSITION", description: "Why your solutions are different and worth getting attention.", className:"unstuck-achievement" },
            { title: "VALUE PROPOSITION CANVAS", description: "How to create value for customers.", className: "proposed-framework" }
        ],
        connections: [
            { className: "yes-button", node: "37", displayText: "Go on" }
        ]
    },
    "37": {
        cards: [
            { title: "Do you know which solution is the right one?", description: "", className: "moment-of-struggle" }
        ],
        connections: [
            { className: "no-button", node: "38", displayText: "No" },
            { className: "yes-button", node: "41", displayText: "Yes" }
        ]
    },
    "38": {
        cards: [
            { title: "Do you need quantitative feedback?", description: "", className: "question" }
        ],
        connections: [
            { className: "no-button", node: "39", displayText: "No" },
            { className: "yes-button", node: "40", displayText: "Yes" }
        ]
    },
    "39": {
        cards: [
            { title: "Do you need qualitative feedback?", description: "", className: "question" }
        ],
        connections: [
            { className: "no-button", node: "37", displayText: "No" },
            { className: "yes-button", node: "42", displayText: "Yes" }
        ]
    },
    "40": {
        cards: [
            { title: "A/B TESTING", description: "Which version performs best regarding the desired outcome.", className: "proposed-method" },
            { title: "FAKE DOOR TESTING", description: "Increase certainty if the solution is desired or not.", className: "proposed-method" }
        ]
    },
    "41": {
        cards: [
            { title: "MINIMUM VIABLE PRODUCT", description: "Build the product and gather validated learnings.", className:"unstuck-achievement" }
        ]
    },
    "42": {
        cards: [
            { title: "ELEVATOR PITCH", description: "What people think of the product, service or idea.", className: "proposed-method" },
            { title: "PROTOTYPING", description: "What people say and how they interact with the solution.", className: "proposed-method" }
        ]
    },
    "43": {
        cards: [
            { title: "Do you know why you're building the product?", description: "", className: "question" }
        ],
        connections: [
            { className: "no-button", node: "44", displayText: "No" },
            { className: "yes-button", node: "45", displayText: "Yes" }
        ]
    },
    "44": {
        cards: [
            { title: "STOP HERE", description: "Reconsider your objectives. Don't do pointless work", className: "breakpoint" }
        ]
    },
    "45": {
        cards: [
            { title: "Do you know the motivations behind building the product?", description: "", className: "question" }
        ],
        connections: [
            { className: "no-button", node: "46", displayText: "No" },
            { className: "yes-button", node: "48", displayText: "Yes" }
        ]
    },
    "46": {
        cards: [
            { title: "Did you talk to clients or stakeholders?", description: "", className: "question" }
        ],
        connections: [
            { className: "no-button", node: "50", displayText: "No" },
            { className: "yes-button", node: "49", displayText: "Yes" }
        ]
    },
    "47": {
        cards: [
            { title: "Can you identify a problem or opportunity from data?", description: "", className: "question" }
        ],
        connections: [
            { className: "no-button", node: "51", displayText: "No" },
            { className: "yes-button", node: "54", displayText: "Yes" }
        ]
    },
    "48": {
        cards: [
            { title: "Do you know who you want to create value for and why?", description: "", className: "question" }
        ],
        connections: [
            { className: "no-button", node: "52", displayText: "No" },
            { className: "yes-button", node: "53", displayText: "Yes" }
        ]
    },
    "49": {
        cards: [
            { title: "OPPORTUNITY ASSESSMENT", description: "Understand problem, context, constraints and desired outcome", className: "proposed-framework" }
        ]
    },
    "50": {
        cards: [
            { title: "STAKEHOLDERS INTERVIEWS", description: "Uncover the varied business needs, ideas, visions and motivations.", className: "proposed-method" }
        ]
    },
    "51": {
        cards: [
            { title: "DATA ANALYSIS", description: "How users behave.", className: "proposed-method" }
        ]
    },
    "52": {
        cards: [
            { title: "PROBLEM HYPOTHESES", description: "Assumed problems, pains, struggles, and jobs-to-be-done.", className: "proposed-framework" },
            { title: "USER HYPOTHESES", description: "Assumed needs, behaviors, motivations, and market-size.", className: "proposed-framework" }
        ]
    },
    "53": {
        cards: [
            { title: "Do you know how the situation will differ after this project?", description: "", className: "question" }
        ],
        connections: [
            { className: "no-button", node: "55", displayText: "No" },
            { className: "yes-button", node: "54", displayText: "Yes" }
        ]
    },
    "54": {
        cards: [
            { title: "OPPORTUNITY", description: "Clear understanding of motivation, desired outcome and what success looks like", className:"unstuck-achievement" }
        ]
    },
    "55": {
        cards: [
            { title: "OBJECTIVES AND KEY RESULTS (OKRs)", description: "How to define and track objectives and their outcomes.", className: "proposed-framework" }
        ]
    },
};